<template>
    <div class="sa-list-component">
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>

                    <template #cell(statoAttuale)="row">
                        <stati-colors-gestione-camere :statoLabel="row.item.statoAttuale || row.item.stato"> </stati-colors-gestione-camere>
                    </template>
                    <template #cell(statoAttualeDataOra)="item">
                        <span>{{ item.item.dataOra }}</span>
                    </template>
                    <template #cell(numeroCartella)="item">
                        <router-link class="sa-edit-link" :to="'/rsapaziente/schedaospite/?idAccettazione=' + item.item.idAccettazione">
                            <span>{{ item.item.numeroCartella }}</span>
                        </router-link>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import statiColorsGestioneCamere from "../../utility/statiColorsGestioneCamere.vue";
import moment from "moment";

export default {
    mixins: { UtilityMixin },
    components: { statiColorsGestioneCamere },
    data() {
        return {
            items: [],
            rows: 0,
            storicoMode: false,
            perPage: 50,
            idLetto: null,
            currentPage: 1,
            /* pathResourceLettoStorico: "/rsapostilettoaccettazione", */
            pathResourceLettoStorico: "/rsapostilettolettostatistorico",
            listKey: 0,
            fields: [
                {
                    label: "*",
                    key: "index",
                    thStyle: "width: 1rem",
                },
                /*  {
                    label: "Piano",
                    key: "nomePiano",
                    sortable: true,
                },
                {
                    label: "Stanza",
                    key: "nomeStanza",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Letto",
                    key: "nome",
                    sortable: true,
                    thStyle: "width: 18rem",
                }, */
                {
                    label: "Stato",
                    key: "statoAttuale",
                    sortable: true,
                    thStyle: "width: 16rem",
                },
                {
                    label: "Data / Ora",
                    key: "dataOra",
                    sortable: true,
                    thStyle: "width: 16rem",
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY - hh:mm:ss");
                        } else {
                            return "-----";
                        }
                    },
                },
                {
                    label: "Numero Cartella",
                    key: "numeroCartella",
                    sortable: true,
                    thStyle: "width: 16rem",
                },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadDataLettiStorico(me.idLetto);
        },
    },
    methods: {
        loadDataLettiStorico(idLetto) {
            let me = this;
            me.idLetto = idLetto;
            let filtroStorico = { idLetto: me.idLetto, forPage: me.perPage, page: me.currentPage };
            UtilityMixin.methods.loadDataResources(me.pathResourceLettoStorico, filtroStorico, me.loadDataLettiStoricoSuccess, me.loadDataLettiStoricoError);
            me.$emit("beforeLoadData");
            // console.log("IDLETTO: ", idLetto);
            // console.log("filtro", filtroStorico);
        },
        loadDataLettiStoricoSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.items = [];
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.listKey++;
        },
        loadDataLettiStoricoError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento dei letti", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>

<style></style>
